import { useEffect, useRef, useState } from "react";
import { animate, useInView } from "framer-motion";
import { Reveal, Eyebrow } from "./Reveal";
import { useLang } from "../i18n";

function CountUp({ value, suffix = "", prefix = "" }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-80px" });
  const [n, setN] = useState(0);
  useEffect(() => {
    if (!inView) return;
    const controls = animate(0, value, { duration: 2.2, ease: [0.16, 1, 0.3, 1], onUpdate: (v) => setN(Math.round(v)) });
    return () => controls.stop();
  }, [inView, value]);
  return <span ref={ref}>{prefix}{n.toLocaleString("it-IT")}{suffix}</span>;
}

export default function Stats() {
  const { t } = useLang();
  const items = [
    { value: 2000, suffix: "+", label: t.stats_clients, testid: "stat-clients" },
    { value: 15, suffix: "+", label: t.stats_years, testid: "stat-years" },
    { value: 2010, label: t.stats_since, testid: "stat-since" },
    { value: 100, suffix: "%", label: t.stats_bespoke, testid: "stat-bespoke" },
  ];
  return (
    <section data-testid="stats-section" className="border-y border-[#1C1A17] bg-[#0A0A09]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 sm:py-28">
        <Reveal><Eyebrow>{t.stats_eyebrow}</Eyebrow></Reveal>
        <div className="mt-10 grid grid-cols-2 lg:grid-cols-4 gap-px bg-[#1C1A17] border border-[#1C1A17]">
          {items.map((s, i) => (
            <Reveal key={s.label} delay={i * 0.08} className="bg-[#080808]">
              <div className="px-6 py-12 sm:py-16">
                <p data-testid={s.testid} className="font-serif text-5xl sm:text-6xl lg:text-7xl font-light tracking-tight text-[#C8A86B] tabular-nums">
                  <CountUp value={s.value} suffix={s.suffix} />
                </p>
                <p className="mt-4 text-[10px] sm:text-xs font-mono uppercase tracking-[0.25em] text-[#827D72]">{s.label}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
